<template>
  <div
    v-if="show && !status"
    class="combos-tip"
  >
    <p>Combine markets from the same event now!</p>
    <a :href="howToPlayUrl">How to Play</a>
    <svg-icon
      icon-class="icon-close"
      @click="close"
    />
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { REGION } from '@ms/config/app'
import 'base/icons/svg/close.svg'

const howToPlayUrl = `https://www.msport.com/${REGION}/promotion/msport_bet_builder.html`

export default {
  name: 'BetBuilderTip',
  setup() {
    const status = localStorage.getItem('combos-tip')
    const show = ref(true)

    const close = () => {
      show.value = false
      localStorage.setItem('combos-tip', true)
    }

    onMounted(() => {
      localStorage.setItem('combos-tip', true)
    })

    return {
      howToPlayUrl,
      status,
      show,
      close
    }
  }
}
</script>

<style lang="scss">
.combos-tip {
  position: relative;
  width: calc(100% - 32px);
  height: 52px;
  box-sizing: border-box;
  padding: 12px 10px 12px 12px;
  border-radius: 9px;
  margin: 10px 0 0 16px;
  background: #2e2e2e;
  color: #fff;
  font-family: Roboto;
  font-size: 12px;
  line-height: 14px;

  a {
    color: #fbc727;
    text-decoration: underline;
  }

  .icon-close {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
[data-mode="light"] .combos-tip {
  background:#fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 13%);
  color: #000;

  a {
    color:#ff7d1e;
  }

  .icon-close {
    color: #999;
  }
}
</style>
